import styled from "styled-components";

export const StyledTextArea = styled.textarea`
  width: 100%;
  resize: none;
`;

export const StyledForm = styled.form`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
